/**
 * addQueryNameToGraphQLDocument
 * Add name to query document
 *
 * @param document
 * @param queryName
 * @returns {*}
 */
export default function addQueryNameToGraphQLDocument(document, queryName) {
	return {
		...document,
		definitions: document.definitions.map(def => ({
			...def,
			...addIf(isQueryOrMutationOperation(def), {name: {kind: 'Name', value: queryName}})
		}))
	};
}

function isQueryOrMutationOperation(definition) {
	return (
		(definition.kind === 'OperationDefinition' && definition.operation === 'query') ||
		definition.operation === 'mutation'
	);
}

function addIf(condition, value) {
	return condition ? value : {};
}
